<template>
    <div style="height: 40px;font-size: 14px;width: 100%;">
        <v-layout row class="ma-0">
            <div style="line-height: 40px;color: rgba(166, 166, 166, 1);width: 56px">图标</div>
            <v-menu bottom right nudge-bottom="45" rounded="2" >
                <template v-slot:activator="{ on, attrs }">
                    <div v-on="on" v-bind="attrs" style="height: 40px;width: 40px;border-radius: 2px;border: 1px solid rgba(128, 128, 128, 1);margin-left: 75px">
                        <v-layout row align-center fill-height justify-center class="ma-0">
                            <div style="font-size: 24px;color: rgba(42, 130, 228, 1)" class="iconfontFamily" v-html="iconCode"></div>
                        </v-layout>
                    </div>
                </template>
                <div style="width: 163px;height: 123px;border-radius: 2px;background: rgba(56, 56, 56, 1);border: 1px solid rgba(166, 166, 166, 1);">
                    <v-layout row class="ma-0">
                        <template v-for="(item,index) in markerIconList">
                            <v-hover :key="index">
                                <div style="height: 40px;width: 40px;border-radius: 2px" :style="{'border':hover ? '1px solid rgba(42, 130, 228, 1)':''}" slot-scope="{ hover }" @click="selectIcon(item)">
                                    <v-layout row align-center fill-height justify-center class="ma-0">
                                        <div style="font-size: 24px;color: rgba(42, 130, 228, 1)" class="iconfontFamily" v-html="item.name"></div>
                                    </v-layout>
                                </div>
                            </v-hover>
                        </template>
                    </v-layout>
                </div>
            </v-menu>
        </v-layout>
    </div>
</template>

<script>
    export default {
        name: "IconPicker",
        props:["iconCode"],
        data(){
            return{
                markerIconList:[
                    {name:'&#xe6b6;',type:1,},
                    {name:'&#xe657;',type:1,},
                    {name:'&#xe653;',type:1,},
                    {name:'&#xe63c;',type:1,},
                    {name:'&#xe65a;',type:1,},
                    {name:'&#xe651;',type:2,},
                    {name:'&#xe654;',type:2,},
                    {name:'&#xe664;',type:2,},
                    {name:'&#xe656;',type:2,},
                ],//图标选择的列表
            }
        },
        methods:{
            selectIcon(item){
                this.$emit("changeIcon",item)
            }
        }
    }
</script>

<style scoped>

</style>
